import axios from "axios";
import apiUrls from "../../api";

export type LrsDocument = "profile" | "pseudonyms" | "modules";

const DOCUMENTS: Record<LrsDocument, { url: string; fileName: string }> = {
  profile: { url: apiUrls.lrs.profile, fileName: "wixar-xapi-profile.json" },
  pseudonyms: { url: apiUrls.lrs.pseudonyms, fileName: "xapi-pseudonyms.csv" },
  modules: { url: apiUrls.lrs.modules, fileName: "xapi-modules.csv" },
};

export const downloadLrsDocument = async (kind: LrsDocument) => {
  const { url, fileName } = DOCUMENTS[kind];
  const response = await axios.get<Blob>(url, { responseType: "blob" });
  const objectUrl = URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
};
